import { render, staticRenderFns } from "./limitations.vue?vue&type=template&id=1e989a6c"
import script from "./limitations.vue?vue&type=script&lang=js"
export * from "./limitations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports